/**
 * Feature Flags
 * Shared type for server-to-client feature flag communication.
 * The server exposes these via GET /api/config/features.
 */

export interface FeatureFlags {
  leaderboard: boolean;
  sharpsports: boolean;
  stripe: boolean;
  inviteOnly: boolean;
  oauthGoogle: boolean;
  oauthApple: boolean;
  /**
   * When on, the chat agent runs a Haiku-based intent classifier on each
   * new user turn and filters the tool list to a 4-8 tool subset for that
   * intent. Default OFF until eval validates ≥85% accuracy on the labeled
   * fixture set.
   */
  chatIntentClassifierV1: boolean;
}

/** Safe fallback — all features disabled until server responds */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  leaderboard: false,
  sharpsports: false,
  stripe: false,
  inviteOnly: false,
  oauthGoogle: false,
  oauthApple: false,
  chatIntentClassifierV1: false,
};
